// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"iu_a bha_rm","PhotoTitleEditForm__cancelBtn":"iu_b bha_rq bha_rp"};